import { IGetAppResponse } from '@biolibtech/biolib-js/src/BioLib/resources/App';
import { resourceApi } from '../../apiHooks/resourceApi';
import { store } from '../../state';
import { utf8ToBase64 } from '../../apiHooks/utils';
import { dataRecordApi } from '@apiHooks';

export interface IGetFileFromDataRecordPayload {
    uri: string;
    path: string;
}

export async function getFileDataFromDataRecord(options: IGetFileFromDataRecordPayload): Promise<Uint8Array> {
    const { uri, path } = options;
    // @ts-ignore
    const resourceResponse = await store.dispatch(resourceApi.endpoints.getAppResource.initiate({ uri }));
    if (resourceResponse.error) {
        throw Error(`Unable to fetch data record: ${JSON.stringify(resourceResponse.error)}}`);
    }
    const { app_version } = resourceResponse.data as IGetAppResponse;
    const resourceVersionUuid = app_version.public_id;
    const resourceVersionResponse = await store.dispatch(
        // @ts-ignore
        dataRecordApi.endpoints.getDataRecordVersion.initiate({ resourceVersionUuid }),
    );
    if (resourceVersionResponse.error) {
        throw Error(`Unable to fetch data record version: ${JSON.stringify(resourceVersionResponse.error)}}`);
    }
    const { presigned_download_url } = resourceVersionResponse.data as { presigned_download_url: string };
    const response = await fetch(
        `${location.origin}/proxy/files/v1/data/?upstream_url_base64=${utf8ToBase64(presigned_download_url)}&path_base64=${utf8ToBase64(path)}`,
    );
    if (response.status !== 200) {
        throw Error(`Response status ${response.status}`);
    }
    const arrayBuffer = await response.arrayBuffer();
    return new Uint8Array(arrayBuffer);
}
